































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'

@Component
export default class KSelect extends Vue {
  @Prop() value: any
  @Prop({default: () => ([]), type: Array}) classes: string[]

  selectValue: any = null

  @Watch('value', {immediate: true})
  __value(value) {
    this.selectValue = value
  }
}
